import React, { useContext, useEffect } from "react";
import { DashboardContext } from "../../context/DashboardContext";
import CountCard from "./CountCard";
import routes from "../../routes";
import * as Icon from "react-feather";

const CountCardContainer = (props) => {
  // const { summary, fetch_dashboard_summary } = useContext(DashboardContext);
  const summary = props.data

  console.log("summary", summary)

  const data = [
    {
      link: routes.policies,
      label: "Policies",
      summary: summary?.totalPolicies,
      icon: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M14.005 15.068l-2.062-2.062.206-.206 2.062 2.062-.206.206zm-3.3-.825l1.237 1.237.207-.206-1.238-1.238-.206.207zm.618-.619l2.063 2.062.206-.206-2.063-2.062-.206.206zm-2.323-9.124c0-.276.224-.5.5-.5h5c.276 0 .5.224.5.5v1.5h2v-2c0-1.104-.896-2-2-2h-6c-1.104 0-2 .896-2 2v2h2v-1.5zm1.516 2.5c-.688.938-.874 2.888-.583 4h2.067l3.906 3.907-3.094 3.093-3.905-3.906v-1.923c-2.406-.925-3.529-3.581-3.553-5.171h-5.354v15h24v-15h-13.484zm-4.167 0c.018 1.191.845 3.213 2.559 4.084v-.084c-.243-1.229-.065-2.862.463-4h-3.022zm3.945 4.889c.005.1-.019.2-.072.289-.093.15-.255.239-.427.239h-.005c-.013.163.037.33.162.455.229.228.598.228.825 0s.229-.597 0-.825c-.131-.134-.31-.18-.483-.158z"/></svg>,
      style: "card-icon-warning",
    },
    {
      link: routes?.quotationRequests,
      label: "Requests",
      summary: summary?.requests,
      icon: <Icon.Globe />,
      style: "card-icon-primary",
    },
    {
      link: routes.quotations,
      label: "Quotations",
      summary: summary?.totalQuotations,
      icon: <Icon.FileText />,
      style: "card-icon-success",
    },
    {
      link: routes.renewals,
      label: "Renewals",
      summary: summary?.totalRenewals,
      icon: <Icon.RefreshCcw />,
      style: "card-icon-danger",
    },
  ];

  

  useEffect(() => {
    try {
      // fetch_dashboard_summary();
    } catch (error) {
      console.log(error.response);
    }
  }, []);

  return (
    <div className="#">
      <CountCard summary={summary} />
    </div>
  );
};

export default CountCardContainer;
